import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import CreateAuthorizationDetail from "components/Auth/CreateAuth/CreateAuthorizationDetail"
import { Breadcrumb, Typography } from 'antd';
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import CreateAuthorizationConfirmation from 'components/Auth/CreateAuth/CreateAuthorizationConfirmation';

import styles from './ModifyCreateAuthorization.module.scss'

const { Title } = Typography;

//Modify Auth Redirect
const ModifyCreateAuthorizationPage = () => {

  const history: any = useHistory();
  const location: any = useLocation();

  const [page, setPage] = useState('modify-create-authorization-page');
  const [retroDos, setRetroDos] = useState('');
  const [authNumber, setAuthNumber] = useState('');

  const triggerConfirmAuthPage = (authNumber: any) => {
    setAuthNumber(authNumber);
    setPage('confirmation-page');
    history.push({
      ...location,
       state: {
         ...location.state,
         previousPath: "confirmation-page"
      }
     });
  }

  return (
    <div className={styles['modify-authorization-page']}>
      <div className={styles['header-title']}>
        <Title level={4}>&nbsp;&nbsp;&nbsp;Modify Authorization</Title>
      </div>
      {page === 'modify-create-authorization-page' && (
        <>
          <div>
            <Breadcrumb>
              <Breadcrumb.Item>
                <HomeOutlined
                  onClick={() => history.push('/quality/overview')}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <UserOutlined />
                  <a onClick={() => history.push('/auth/create')}>Select Member</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <UserOutlined />
                  <a>Create Authorization</a>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <CreateAuthorizationDetail
            authDetailState={location?.state.authDetailState}
            authMember={location?.state.authMember[0]}
            provider={location?.state.provider}
            retroDos={retroDos}
            setRetroDos={setRetroDos}
            triggerConfirmAuthPage={triggerConfirmAuthPage}
            previousAuthNumber={location?.state.previousAuthNumber}
          />
        </>
      )}

      {page === 'confirmation-page' && (
        <>
          <div>
            <Breadcrumb>
              <Breadcrumb.Item>
                <HomeOutlined
                  onClick={() => history.push('/quality/overview')}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <UserOutlined />
                  <a onClick={() => history.push('/auth/create')}>Select Member</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <UserOutlined />
                  <a onClick={() => setPage('modify-create-authorization-page')}>Create Authorization</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <UserOutlined />
                  <a>Authorization Confirmation</a>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <CreateAuthorizationConfirmation
            authNumber={authNumber}
            setPage={setPage}
          />
        </>
      )}
    </div>
  );
}

export default ModifyCreateAuthorizationPage;